<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <div class="solutionCaseBanner">
        <div class="solutionCaseBannerIn">智慧教育解决方案</div>
    </div>
    <section class="solutionConcept">
      <div class="solutionCaseBox" style="padding-bottom: 0">
        <div class="solutionConceptBox">
          <div class="solutionConceptBoxR">
            <img src="../../../static/images/solutionConceptPic5.jpg" />
          </div>
          <div class="solutionConceptBoxL">
            <div class="solutionConceptIn">
              <div class="solutionConceptInTit">项目概念</div>
              <div class="solutionConceptInConn">
                提供教学、科研和综合信息服务的宽带多媒体网络，跟踪和使用最新的IPv6的应用和技术，便于科研探索，辅助培育IPv6的技术型人才。
              </div>
            </div>
            <div class="solutionConceptArr"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="solutionIncome">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit">客户收益</div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionDetailIcon05.png" />
            <div class="solutionIncomeConn">
              提升校园网络和应用信息<br />安全的级别，降低校园师<br />生个人信息的泄露风险
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon06.png" />
            <div class="solutionIncomeConn">
              快速实现平行校园内部教<br />学资源的充分共享，提高<br />教学资源使用效率
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon11.png" />
            <div class="solutionIncomeConn">
              打通教育管理机构与各校园<br />之间的数据交换，实现各学<br />校之间学籍信息互查互访
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon04.png" />
            <div class="solutionIncomeConn">
              实现校园安全监控视频的随<br />时调用，提供全方位、多维<br />度的校园安全保障
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="solutionAdvantage">
      <div class="solutionAdvantageBox">
        <div class="solutionAdvantageTit">项目优势</div>
        <img src="../../../static/images/solutionAdvantageIcon05.png" />
        <div class="solutionAdvantageConn" style="left: 176px; top: 230px">
          <div class="solutionAdvantageConnMsg">
            建立教育云平台&nbsp;&nbsp;教育资源共享
          </div>
        </div>
        <div class="solutionAdvantageConn" style="right: 156px; top: 230px">
          <div class="solutionAdvantageConnMsg">
            建设平安校园&nbsp;&nbsp;保安监控随时调用
          </div>
        </div>
        <div class="solutionAdvantageConn" style="left: 440px; bottom: 30px">
          <div class="solutionAdvantageConnMsg center">
            数据高效管理<br />提供安全、快捷、规范、便利的上网环境
          </div>
        </div>
      </div>
    </section>
    <section class="solutionValue">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit">项目价值</div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionValuePic01.png" />
            <div class="solutionIncomeConn">
              提升科研创新能力,帮助高校的<br />通信网络系统向下一代互联网升级
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic02.png" />
            <div class="solutionIncomeConn">
              培训科研人才,同时智慧<br />校园综合解决方案的双栈化运行
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic03.png" />
            <div class="solutionIncomeConn">
              构建下一代互联网<br />全新系统及多元化服务
            </div>
          </li>
        </ul>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage:'../../../static/images/solutionCaseBanner2.jpg?011901',
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./solution";
.solutionCase {
    .solutionCaseBanner{
         background:url(../../../static/images/solutionCaseBanner2.jpg?011902) no-repeat center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/solutionCase3.vue